import { useEffect, useState, useMemo } from 'react';
import { getUserSession } from "../../../../util/core/Session";
import './MainSideBar.css';
import SideBar from './SideBar';
import { DEFAULT_CONFIGS } from '../../Login/configs/default_configs';
import axios from 'axios';
import config from '../../../../../application/config/config';

function MainSideBar() {
  const userSession = getUserSession();
  const defaultLogo = '.././AdminLTELogo.png'

  const sidebarInfo = document.getElementsByTagName("body")[0];

  const [showLogo, setShowLogo] = useState(false);
  const [screenConfigs, setScreenConfigs] = useState(DEFAULT_CONFIGS);

  function onClassChange(node, callback) {
    if (node !== null) {
      let lastClassString = node.classList.toString();
      const mutationObserver = new MutationObserver((mutationList) => {
        for (const item of mutationList) {
          if (item.attributeName === "class") {
            const classString = node.classList.toString();
            if (classString !== lastClassString) {
              callback(mutationObserver);
              lastClassString = classString;
              break;
            }
          }
        }
      });

      mutationObserver.observe(node, { attributes: true });

      return mutationObserver;
    }
  };

  const minimizeSidebarOnMobile = () => {
    const defaultBodyClass = ['sidebar-closed', 'sidebar-collapse']
    const classSelector = '.sidebar-mini';
    const body = document.querySelector(classSelector);

    if (!body) return;

    body.classList.remove('sidebar-open');
    body.classList.add(...defaultBodyClass);
  };

  const loadScreenConfigs = async () => {
    const data = {
      core_application_instance_id: userSession.user.application_instance_id,
      urlVa: window.location.href
    }

    axios.post(`${config.endpoints.backend}core/loginconfigs/getloginconfigs`, data).then((resp) => {
      let server_configs = resp.data;

      if (server_configs.logo_img) {
        server_configs.logo_img = server_configs.logo_img;
      } else {
        server_configs.logo_img = DEFAULT_CONFIGS.logo_img;
      }

      if (server_configs.isotype_img) {
        server_configs.isotype_img = server_configs.isotype_img;
      } else {
        server_configs.isotype_img = DEFAULT_CONFIGS.isotype_img;
      }

      if (server_configs.background_img) {
        server_configs.background_img = server_configs.background_img;
      } else {
        server_configs.background_img = DEFAULT_CONFIGS.background_img;
      }

      setScreenConfigs(server_configs);
    });
  };

  useEffect(() => { loadScreenConfigs() }, []);

  onClassChange(sidebarInfo, () => { setShowLogo(sidebarInfo.classList.contains("sidebar-collapse")); });

  const main_side_bar = useMemo(() => {
    return (
      <>
        <aside className="main-sidebar sidebar-dark-primary elevation-4">
          {/*<!-- Brand Logo -->*/}
          <a href="/" className="brand-link" style={{ height: 50 }}>
            {showLogo && <img src={screenConfigs?.isotype_img || defaultLogo} className="brand-image" />}
            {screenConfigs?.logo_menu_img && sidebarInfo !== null ? (
              <span className="brand-text font-weight-light"><img src={screenConfigs?.logo_menu_img} className="brand-image" /></span>
            ) : (
              <span className="brand-text font-weight-light">{userSession.user.application_name}</span>
            )}
          </a>
          <SideBar sidebarInfo={sidebarInfo} showLogo={showLogo} setShowLogo={setShowLogo} />
        </aside>
      </>
    )
  }, [showLogo, screenConfigs])


  return (
    <>
      {main_side_bar}

      <div id='sidebar-overlay' onTouchStart={minimizeSidebarOnMobile} />
    </>
  );
}
/*
  <a href="/" className="brand-link">
    <img src={screenConfig?.isotype_img} className="brand-image" />
    <span className="brand-text font-weight-light">{userSession.user.application_name}</span>
  </a>
*/

export default MainSideBar;